import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface Auth {
  user: User;
  Token: string;
}

export interface User {
  IdUser: number;
  IdProfessional: null;
  Companies: null;
  Name: string;
  Email: string;
  Cpf: string;
  Phone: string;
  PlanId: number
  IdCompany: number
}


interface InitialStateProps {
  auth: Auth | null
}

const initialState: InitialStateProps = {
  auth: null,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Auth>) => {
      state.auth = action.payload;
    },
    logout: (state) => {
      state.auth = null
    },
  },
});

export const { login, logout } = AuthSlice.actions;

export default AuthSlice.reducer;
